import { FilterChip } from "plos/src/components/Chip";
import { PopoverSelect } from "plos/src/components/PopoverSelects";
import { ListBoxItem, Selection } from "react-aria-components";
import { useTranslation } from "react-i18next";
import styles from "../../FilterPopovers/filterPopover.module.css";
import { MonthFilterProps } from "./types";

const MonthFilter = ({
  prizePhase,
  handlePrizePhaseChange,
  finishedPhases,
}: MonthFilterProps) => {
  const { t } = useTranslation("prizes");
  const handleFilterChange = (keys: Selection) => {
    const key = Array.from(keys)[0];
    if (key == null) return;
    const phaseId = Number(key);
    handlePrizePhaseChange(phaseId);
  };

  const selectedPhase = finishedPhases.find((phase) => phase.id === prizePhase);
  const selectedPhaseId = selectedPhase && selectedPhase.id;

  const chipLabel = selectedPhase
    ? selectedPhase.name
    : finishedPhases[finishedPhases.length - 1].name;

  return (
    <PopoverSelect
      popoverTrigger={
        <FilterChip
          label={t("label.filterByMonth", "Filter by month")}
          selectedOption={[
            { label: chipLabel, value: String(selectedPhaseId) },
          ]}
        />
      }
      selectedKey={selectedPhaseId}
      handleOnChange={handleFilterChange}
    >
      {finishedPhases.map(({ name, id }) => (
        <ListBoxItem
          key={id}
          id={id}
          data-selected={id === prizePhase}
          className={styles.popoverListItem}
          textValue={name}
        >
          {name}
        </ListBoxItem>
      ))}
    </PopoverSelect>
  );
};

export default MonthFilter;
